import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FileExportForUseInModal } from '../../../_lib/components/FileExport/FileExportForUseInModal';

type TicketBookingExportCsvProps = {
  approximateFileSize: number;
  fileNameIncludingExtension: string;
  url: string;
};

function TicketBookingExportCsv({ approximateFileSize, fileNameIncludingExtension, url }: TicketBookingExportCsvProps) {
  const { t } = useSonTranslation('TicketBooking');

  return (
    <FileExportForUseInModal
      approximateFileSize={approximateFileSize}
      fileNameIncludingExtension={fileNameIncludingExtension}
      fileExtension="csv"
      fileMimeType="text/csv"
      url={url}
      buttonText={t('exportCsv.downloadFile')}
      liveRegionMessage={t('exportCsv.downloadStarted')}
    />
  );
}

export const TicketBookingExportCsvView = asFetchableView(TicketBookingExportCsv);
export type TicketBookingExportCsvView = ComponentProps<typeof TicketBookingExportCsvView>;
